import type { Meta } from '../../../packages/contracts/src/index.ts';
import { contentMeta } from '../../../packages/slc-web/src/content.ts';

/** Paging follows the rows received from the addon, before optional metadata
 * is rejected or repeated title identities are removed. */
export function addonCatalogPage(response: { metas: unknown; received?: number }): { items: Meta[]; received: number } {
  if (!Array.isArray(response.metas) || response.metas.length > 200)
    throw Error('This catalog returned an unsupported response.');
  const received = response.received ?? response.metas.length;
  if (!Number.isInteger(received) || received < response.metas.length || received > 200)
    throw Error('This catalog returned an invalid page count.');
  const seen = new Set<string>();
  const items = response.metas.flatMap(item => {
    try {
      const meta = contentMeta(item), key = JSON.stringify([meta.type, meta.id]);
      if (seen.has(key)) return [];
      seen.add(key);
      return [meta];
    } catch { return []; }
  });
  return { items, received };
}

export function addonCatalogNextOffset(offset: number, received: number): number | null {
  const next = offset + received;
  return Number.isInteger(offset) && offset >= 0 && Number.isInteger(received) && received > 0 && received <= 200 && next <= 10000
    ? next : null;
}

export function repeatedAddonCatalogPage(previous: readonly Pick<Meta, 'type' | 'id'>[], next: readonly Pick<Meta, 'type' | 'id'>[]): boolean {
  // A page with no accepted metadata has no identities to compare. Its raw
  // count can still lead to a later page containing usable titles.
  return next.length > 0 && JSON.stringify(previous.map(meta => [meta.type, meta.id])) === JSON.stringify(next.map(meta => [meta.type, meta.id]));
}
